import { Module } from 'vuex'
import { IRootState, IProductsState } from '@/@types'
import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const products: Module<IProductsState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default products
